import { derived, get } from "svelte/store";
import {
  active_video_store,
  normalized_video_store,
  video_store,
} from "../Utils/stores";

/**
 * Get the next video
 * @param $video_store - The raw video store
 * @param $normalized_video_store - The neormalized video store
 * @param{{video: string?, category: string?, playlist: string?, project: string?}} activeState
 *
 */
function getNext($video_store, $normalized_video_store, activeState) {
  const result = {
    nextState: {
      video: null,
      category: null,
      playlist: null,
    },
    nextVideo: null,
  };
  console.log({activeState})
  if (!activeState.video) {
    return result;
  }

  // If we had an active playlist
  if (activeState.playlist && activeState.video) {
    const playlist = $normalized_video_store.playlists[activeState.playlist];
    if (!playlist) {
      console.warn("No playlist")
      return result;
    }

    const videoIndex = playlist.videos.findIndex(
      (v) => v.slug.current === activeState.video
    );

    // if we haven't found, or it is the last one then no next
    const finalVideoIndex = playlist.videos.length - 1;
    if (videoIndex < 0 || videoIndex > playlist.videos.length - 1) {
      console.warn("Video not in playlist")
      return result;
    }

    if (videoIndex === finalVideoIndex) {
      return result;
    }
    result.nextState.playlist = activeState.playlist;
    result.nextState.video = playlist.videos[videoIndex + 1].slug.current;
    result.nextVideo = $normalized_video_store.videos[result.nextState.video];
  }

  if (activeState.category && activeState.video) {
    const category = $normalized_video_store.categories[activeState.category];
    if (!category) {
      console.warn("No matching category")
      return result;
    }

    const videoIndex = category.videos.findIndex(
      (v) => v.slug.current === activeState.video
    );

    const finalCategoryIndex = category.videos.length - 1;
    // We are at the end of the category
    if (videoIndex < 0 || videoIndex > finalCategoryIndex - 1) {
      return result;
    }

    result.nextState.category = activeState.category;
    result.nextState.video = category.videos[videoIndex + 1].slug.current;
    result.nextVideo = $normalized_video_store.videos[result.nextState.video];
  }

  if (activeState.project && activeState.video) {
    const project = $normalized_video_store.projects[activeState.project];
    if (!project) {
      console.warn("No matching project")
      return result;
    }

    const videoIndex = project.videos.findIndex(
      (v) => v.slug.current === activeState.video
    );

    const finalProjectIndex = project.videos.length - 1;
    // We are at the end of the project
    if (videoIndex < 0 || videoIndex > finalProjectIndex - 1) {
      return result;
    }

    result.nextState.project = activeState.project;
    result.nextState.video = project.videos[videoIndex + 1].slug.current;
    result.nextVideo = $normalized_video_store.videos[result.nextState.video];
  }
  return result;
}
/**
 * @param{{video: string?, category: string?, playlist: string?}} activeState
 */
export const getNextData = (activeState) => {

  const next= getNext(get(video_store), get(normalized_video_store), activeState);
  console.log(next);
  return next;
}

const getNextNFromVideoList = (currentSlug, videoList, n) => {
  const currentIndex = videoList.findIndex(
    (v) => v.slug.current === currentSlug
  );
  return videoList.slice(currentIndex + 1, currentIndex + 1 + n);
};

const getNextVideoInCategory = (
  activeCategory,
  activeVideo,
  $normalizedVideoStore
) => {
  const nextTwo = getNextNFromVideoList(
    activeVideo.slug.current,
    activeCategory.videos,
    2
  );
  return nextTwo.map((v) => {
    return {
      category: activeCategory.slug.current,
      video: v.slug.current,
      preview: $normalizedVideoStore.videos[v.slug.current],
    };
  });
};

const inPlaylist = ($active_video_store) => {
  return (
    $active_video_store.active_playlist && $active_video_store.active_video
  );
};

const getNextVideoInPlaylist = (
  active_playlist,
  active_video,
  $normalized_video_store
) => {
  const nextTwo = getNextNFromVideoList(
    active_video.slug.current,
    active_playlist.videos,
    2
  );
  return nextTwo.map((v) => {
    return {
      playlist: active_playlist.slug.current,
      video: v.slug.current,
      preview: $normalized_video_store.videos[v.slug.current],
    };
  });
};

const inProject = ($active_video_store) => {
  return $active_video_store.active_project && $active_video_store.active_video;
};

const getNextVideoInProject = (
  active_project,
  active_video,
  $normalized_video_store
) => {
  const nextTwo = getNextNFromVideoList(
    active_video.slug.current,
    active_project.videos,
    2
  );
  return nextTwo.map((v) => {
    return {
      project: active_project.slug.current,
      video: v.slug.current,
      preview: $normalized_video_store.videos[v.slug.current],
    };
  });
};

const inCategory = ($active_video_store) =>
  $active_video_store.active_category && $active_video_store.active_video;

export const next_up_store = derived(
  [active_video_store, normalized_video_store],
  ([$active_video_store, $normalized_video_store]) => {
    if (inCategory($active_video_store)) {
      const nextUp = getNextVideoInCategory(
        $active_video_store.active_category,
        $active_video_store.active_video,
        $normalized_video_store
      );

      return {
        finished: nextUp.length === 0,
        videos: nextUp,
      };
    }

    if (inPlaylist($active_video_store)) {
      const nextUp = getNextVideoInPlaylist(
        $active_video_store.active_playlist,
        $active_video_store.active_video,
        $normalized_video_store
      );
      return {
        finished: nextUp.length === 0,
        videos: nextUp,
      };
    }

    if (inProject($active_video_store)) {
      const nextUp = getNextVideoInProject(
        $active_video_store.active_project,
        $active_video_store.active_video,
        $normalized_video_store
      );
      return {
        finished: nextUp.length === 0,
        videos: nextUp,
      };
    }

    return {
      finished: false,
      videos: [],
    };
  }
);
